import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { FreeViewLimitService, FreeViewLimitServiceImpl } from './service/free-view-limit.service';

export const freeViewLimitModule = (bind: interfaces.Bind) => {
    bind(FreeViewLimitService).to(FreeViewLimitServiceImpl);
};
